import { render, staticRenderFns } from "./ModifierOption.vue?vue&type=template&id=66a22259"
import script from "./ModifierOption.vue?vue&type=script&lang=js"
export * from "./ModifierOption.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports